module.exports = __webpack_public_path__ + "static/top_check_sp-da381e978dd5bf563d7d8d8fad7d810e.jpg";